<template>
    <!-- 统一身份认证 -->
    <div class="authVerifyWrap">        
    </div>
</template>
<script>
import Axios from 'axios';
import { env } from '../../dataJson/custom.js'
import { setConfig } from "@/api/user";
import { generator } from "@/api/colinfo"
import { getItem, setItem, getUserInfo } from "@/common/utils/localStorage.js";
import MD5 from "../../common/utils/MD.js"

export default {
    name: "Login",
    data() {
        return {
            loading:null
        };
    },
    created() {
        let vm = this;        
    },
    mounted() {
        let vm = this;
        vm.loading = this.$loading({
            text: "加载中...", // 设置 loading 文本为 "加载中"
            spinner: "el-icon-loading", // 使用 Element UI 提供的加载图标
            background: "rgba(255, 255, 255, 0.7)", // 设置 loading 遮罩层背景色为半透明黑色
        });
        if(vm.$route.query.caslogin && vm.$route.query.caslogin == 'suc'){
            Axios.get(env+'/ttv3/security/core/cas/login/sucinfo', {
                params: {
                    sessionId: vm.$route.query.sessionId
                }
            }).then(res => {
                if(res.data.status){
                    vm.setLoginInfo(res.data);
                    vm.loading.close();
                }
            }).catch(err => {
                vm.loading.close();
            });
        }else{
            vm.loading.close();
            // window.location.href = 'http://192.168.7.188:1234/ttv3/security/core/cas/login?deviceType=1'; //周航
            // window.location.href = 'http://172.19.40.3:1234/ttv3/security/core/cas/login?deviceType=1'; //鄂州职业大学
            // window.location.href = 'https://read.ezu.cn/readermain/ttv3/security/core/cas/login?deviceType=1'; //鄂州职业大学域名
            window.location.href = 'http://172.19.40.3/readermain/ttv3/security/core/cas/login?deviceType=1'; //鄂州职业大学
        }
    },    
    methods: {
        //处理登录后的数据
        setLoginInfo(res){
            let vm = this;
            setItem("token", res.data.token);
            setItem("orgId", res.data.orgId);
            setItem("userId", res.data.pkid);
            setItem("userInfo", res.data);
            setItem("authKey", res.data.loginRedisKey);
            setItem("demoSignal", res.data.demoSignal);
            setItem("account", res.data.account);
            
            let userInfo = getUserInfo();
            let authKey = MD5(userInfo.orgId + "|#|" + userInfo.pkid + "|#|" + userInfo.token)
            let obj = {
                "authKey": authKey,
                "visitType": 2,
                "visitUrl": location.href,
                "visitFunc": "",
            };
            generator(obj).then((res) => {
                setItem("sign", res.data);
                if(res.code == "") {
                    vm.$router.push({name:"Login"})
                } else {
                    vm.getSetConfig();
                }
                vm.logining = false;
            }).catch(err => {                
                vm.logining = false;
            });
        },
        //获取权限显示
        getSetConfig(){
            let vm = this,
                obj = {
                    // orgId: getUserInfo().orgId,
                    visitType: 2,
                    visitUrl: '',
                    visitFunc: '',
                };
            setConfig(obj).then(res => {
                if(res.status){
                    // t.config = res.data;
                    let configData = [],
                        list = {};
                    for(var i = 1;i<=40;i++){
                        let list = {type:i, orgId:getUserInfo().orgId, dataStatus:1, enableStatus: 2}; //默认不显示
                        res.data.map((item, index) =>{
                            if(item.type == i){
                                // list.pkid = item.pkid;
                                list.enableStatus = item.enableStatus;
                                return true;
                            }
                        });
                        configData.push(list);
                    }
                    // t.config = configData;
                    setItem('config', JSON.stringify(configData));
                    vm.$message({
                        message: "登录成功！",
                        type: "success"
                    });
                    if(getItem('remindLink') != null) {
                        vm.$router.push({ path: getItem('remindLink') });
                        removeItem('remindLink');
                        removeItem('dircode');
                    } else {
                        vm.$router.push({name:"HomePage"})
                    }
                }
            }).catch(err => {

            });
        },
    }
};
</script>
 
<style lang="scss" scoped>
.authVerifyWrap{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #c3ecff;
}
</style>


// WEBPACK FOOTER //
// src/views/Login/authVerify.vue